import React, { Fragment } from 'react';
import { NavLink} from 'react-router-dom';
import '../scss/main.scss'

const NavBar = () => {
    return (
        <Fragment>
            <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top px-2">
                <div className="navbar-brand d-flex">
                    <div className="img-container" >
                        <a href="/">
                        <img src="../assets/logox50.png" alt="brand-logo" className="pt-2" />
                        </a>
                    </div>
                    <span className="brand-name">
                        Edugen <br/>
                        Technical Institute
                    </span>
                </div>

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navigations" aria-controls="navigations" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="navigations collapse navbar-collapse" id="navigations">
                    <ul className="navbar-nav mx-auto mb-lg-0 ">
                        <li className="nav-item px-3">
                            <NavLink className="nav-link active" aria-current="page" to="/">Home</NavLink>
                        </li>
                        <li className="nav-item px-3">
                            <NavLink className="nav-link" to="/about">About Us</NavLink>
                        </li>
                        <li className="nav-item px-3">
                            <NavLink className="nav-link" to="/contact">Contact</NavLink>
                        </li>
                    </ul>
                    <div className="buy-form px-3">
                        <NavLink to="/signup" className="purchase-btn btn btn-info text-white">
                            Entry form
                        </NavLink>
                    </div>
                </div>
            </nav>
        </Fragment>
    );
}

export default NavBar;